import apiFetch from '../apiFetch'

export default function (token, templateTypeId) {
  return apiFetch({ endPoint: `template?templateTypeId=${templateTypeId}`, method: 'POST', token: token })
}
